import { useQuery } from "@tanstack/react-query";
import entryPointService from "../api/entryPointService";

export const useEntryPoint = () => {
  const { getInfo } = entryPointService();

  return useQuery({
    queryKey: ["get-entry-info"],
    queryFn: async () => {
      const res = await getInfo();
      return res.data;
    },
  });
};
